<template>
    <v-app class="us-v-app">
        <v-app-bar color="blue-grey" dense dark app>
            <v-btn icon @click="goBack">
                <v-icon style="font-size:2rem;">mdi-chevron-left</v-icon>
            </v-btn>
            <v-toolbar-title style="font-size:1rem;">邀请新用户</v-toolbar-title>
            <v-spacer></v-spacer>
        </v-app-bar>
        <v-content>
            <v-container style="padding-top:2rem;">
              <v-card style="width:90%;margin:auto;" flat>
                <v-card-text style="text-align:center;">
                    <div style="font-size:1.6rem;margin-top:1rem;margin-bottom:1.8rem;line-height:2.2rem;">{{userName}}</div>
                    <v-divider style="border-color:#eee;"></v-divider>
                    <div style="margin-top:1rem;margin-bottom:1rem;">扫一扫二维码， 加入</div>
                    <ShareQrCode ref="shareQrCode" title="邀请码" :visible.sync="shareVis" />
                    <div style="text-align:center;margin:0.5rem 0;color:#F56C6C;">
                        有效期 {{shareExpiry}} 分钟.
                    </div>
                </v-card-text>
              </v-card>
              <div style="margin-top:1rem;font-size:0.85rem;color:#808080;text-align:center;">提示：点击右上角分享二维码或链接</div>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
import ShareQrCode from '../../components/ShareQrCodeV2'
import wx from 'weixin-js-sdk'
export default {
  components: {
    ShareQrCode
  },
  props: {
    value: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      userName: '',
      userCode: '',
      shareCode: '',
      shareExpiry: 10,
      role: 'common',
      shareVis: false
    }
  },
  computed: {
  },
  mounted() {
    var that = this
    that.userCode = that.$route.query.code
    that.userName = that.$route.query.name
    that.shareExpiry = that.$route.query.expiry
    var qrcode = that.$route.query.qrcode
    // console.log('qrcode', qrcode);
    that.showInviteCode(qrcode)
    that.setShareCode(qrcode)
    that.configShare();
  },
  created() {

  },
  methods: {
    goBack() {
      var that = this;
      that.$router.goBack()
    },
    // 显示邀请码
    showInviteCode(code) {
      var that = this
      that.$refs.shareQrCode.setQrContent(code)
      that.shareVis = !that.shareVis
    },
    // 配置分享
    configShare() {
      var that = this
      if (!that.shareCode) {
        return
      }
      var sImage = that.$AppHelper.getShareLink('/res/logo.png')

      var shareLink = that.$AppHelper.getShareLink('/JoinHhUser?share_code=' + that.shareCode);
      wx.updateAppMessageShareData({
        title: '《' + that.userName + '》 邀请您加入',
        desc: '有效期' + that.shareExpiry + '分钟',
        link: shareLink,
        imgUrl: sImage,
        success: function() {
          // 设置成功
          console.log('配置分享内容.OK');
        },
        error: function() {
          console.log('配置分享内容.ERROR');
        }
      })
    },
    setShareCode(href) {
      var that = this
      // 截取参数的那一个片段，即从？开始
      const str = href.substr(href.indexOf('?') + 1, href.length)

      // 将&分隔符分开
      const params = str.split('&')

      for (let i = 0; i < params.length; i++) {
        const item = params[i]

        var arr = item.split('=')
        if (arr[0] === 'share_code') {
          that.shareCode = arr[1]
          return
        }
      }
    }

  }
}
</script>

<style scoped>
.us-v-app{
  background-color: #f2f2f2;
}
</style>
